module.exports = __webpack_public_path__ + "img/SunGrow-icon.4b35bed5.png";